import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { Training as TR } from '../../features/training'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

export function Training(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  return <TR id={props.id} />
}
